module.exports = __webpack_public_path__ + "static/media/Education_Flyer.3dd300a4.jpg";